

























import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Organization from "@/store/entities/organization";

@Component
export default class EditOrganization extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;

  organization: Organization = new Organization();

  organizations: any[] = new Array<any>();

  get loading() {
    return this.$store.state.organization.loading;
  }

  get permissions() {
    return this.$store.state.organization.permissions
  }


  save() {
    (this.$refs.organizationForm as any).validate(async (valid: boolean) => {
      if (valid) {

        await this.$store.dispatch({
          type: 'organization/update',
          data: this.organization
        });
        (this.$refs.organizationForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);
      }
    })
  }

  cancel() {
    (this.$refs.organizationForm as any).resetFields();
    this.$emit('input', false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    } else {
      this.organization = Util.extend(true, {}, this.$store.state.organization.editOrganization);

    }
  }

  organizationRule = {
    displayName: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('displayName')),
      trigger: 'blur'
    }],
    code: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('code')),
      trigger: 'blur'
    }],
  }
}
